/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reingest_Approval_ApproveInputs */

const es_components_reingest_approval_approve = /** @type {(inputs: Components_Reingest_Approval_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const en_components_reingest_approval_approve = /** @type {(inputs: Components_Reingest_Approval_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Components_Reingest_Approval_ApproveInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reingest_approval_approve = /** @type {((inputs?: Components_Reingest_Approval_ApproveInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reingest_Approval_ApproveInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reingest_approval_approve(inputs)
	return en_components_reingest_approval_approve(inputs)
});
export { components_reingest_approval_approve as "components.reingest_approval.approve" }